<div class="fp-in-container" [formGroup]="fpForm">
    <div class="fp-in-view">
        @if(isOTPRequested) {
        <div class="reset-password">
            <h2 class="fp-in-label">Reset Password</h2>
            <p class="fp-verification-text">OTP sent to **{{requesteEmail}}.</p>

            <div class="fp-in-form">
                <ccdl-input
                    [labelName]="'OTP'"
                    controlId="resetOTP"
                    type="otp"
                    [control]="getControl('resetOTP')"
                    [errorConfig]="resetErrorConfig"
                    [displayErrors]="isSubmitTriggered"
                    autocomplete="one-time-code"></ccdl-input>
                @if(isValidOTP) {
                <ccdl-input
                    [labelName]="'New password'"
                    [showOrHideText]="true"
                    [type]="'password'"
                    controlId="newPassword"
                    [control]="getControl('newPassword')"
                    [displayErrors]="isSubmitTriggered"
                    [errorConfig]="passwordErrorConfig"
                    autocomplete="new-password"></ccdl-input>
                <ccdl-input
                    [labelName]="'Confirm new password'"
                    [showOrHideText]="true"
                    [type]="'password'"
                    controlId="confirmPassword"
                    [control]="getControl('confirmPassword')"
                    [displayErrors]="isSubmitTriggered"
                    [errorConfig]="confirmPasswordErrorConfig"
                    autocomplete="new-password"></ccdl-input>
                }
            </div>
            <div class="fp-action-btn">
                <ccdl-button [btnLabel]="'CANCEL'"
                    (onClick)="cancelFlow1Click()"
                    [btnType]="'default'"></ccdl-button>
                <ccdl-button [btnLabel]="'RESET PASSWORD'"
                    (onClick)="resetPasswordClick()"
                    [btnType]="'primary'"></ccdl-button>
            </div>
        </div>
        } @else if(isHaveOTP) {
        <div class="have-otp">
            <h2 class="fp-in-label">Reset Password</h2>
            <p class="fp-verification-text">Enter your registered email address,
                OTP, and new password.
            </p>
            <div class="fp-in-form">
                <ccdl-input
                    [labelName]="'Email address'"
                    controlId="emailId"
                    [control]="getControl('email')"
                    [displayErrors]="isSubmitTriggered"
                    [errorConfig]="emailErrorConfig"
                    autocomplete="email"></ccdl-input>
                <ccdl-input
                    [labelName]="'OTP'"
                    controlId="resetOTP"
                    type="otp"
                    [control]="getControl('resetOTP')"
                    [errorConfig]="resetErrorConfig"
                    [displayErrors]="isSubmitTriggered"
                    autocomplete="one-time-code"></ccdl-input>
                <ccdl-input
                    [labelName]="'New password'"
                    [showOrHideText]="true"
                    [type]="'password'"
                    controlId="newPassword"
                    [control]="getControl('newPassword')"
                    [displayErrors]="isSubmitTriggered"
                    [errorConfig]="passwordErrorConfig"
                    autocomplete="new-password"></ccdl-input>
                <ccdl-input
                    [labelName]="'Confirm new password'"
                    [showOrHideText]="true"
                    [type]="'password'"
                    controlId="confirmPassword"
                    [control]="getControl('confirmPassword')"
                    [displayErrors]="isSubmitTriggered"
                    [errorConfig]="confirmPasswordErrorConfig"
                    autocomplete="new-password"></ccdl-input>
            </div>
            <div class="fp-action-btn">
                <ccdl-button [btnLabel]="'CANCEL'"
                    (onClick)="cancelFlow2Click()"
                    [btnType]="'default'"></ccdl-button>
                <ccdl-button [btnLabel]="'RESET PASSWORD'"
                    (onClick)="resetPasswordClick()"
                    [btnType]="'primary'"></ccdl-button>
            </div>
        </div>
        } @else {
        <div class="request-otp">
            <h2 class="fp-in-label">Forgot Password</h2>
            <p class="fp-verification-text">Please enter your registered email
                address to receive an OTP.
            </p>
            <div class="fp-in-form">
                <ccdl-input
                    [labelName]="'Email address'"
                    controlId="emailId"
                    [control]="getControl('email')"
                    [displayErrors]="isSubmitTriggered"
                    [errorConfig]="emailErrorConfig"
                    autocomplete="email"></ccdl-input>
            </div>
            <div class="fp-btn">
                <ccdl-button [btnLabel]="'Send OTP'" (onClick)="requestOTP()"
                    [btnType]="'primary'"></ccdl-button>
                <p class="fp-btn-link">
                    <ccdl-link [linkText]="'Already have an OTP?'"
                        (onClick)="haveOTPClick()"
                        [linkUnderLine]="true"></ccdl-link>
                </p>
            </div>
        </div>
        }
    </div>
</div>